import { ICS2ArrivalNotificationMessage } from 'store/declarations/eu/ics2/arrival/ics2-arrival-notification-declaration';
import { getIcs2NotificationMessageLabel } from 'store/declarations/eu/ics2/ics2-notification';
import Drawer from 'components/ui/base/drawer/Drawer';
import { ArrivalMessageTypes } from './arrivalMessageUtils';
import ArrivalMessageDetails from './ArrivalMessageDetails';

type Props = {
    message?: ICS2ArrivalNotificationMessage;
    onClose: () => void;
};

const ArrivalMessagesDrawer = ({ message, onClose }: Props) => {
    const label = getIcs2NotificationMessageLabel(message?.messageType);
    const isRejection = message?.messageType === ArrivalMessageTypes.REJECTION;

    return (
        <Drawer
            open={!!message}
            onClose={onClose}
            width={820}
            warning={isRejection}
            caution={!isRejection}
            title={label ?? 'Customs message'}
        >
            {message && <ArrivalMessageDetails message={message} onBack={onClose} />}
        </Drawer>
    );
};

export default ArrivalMessagesDrawer;
